import React from "react";

function ViewState({ data }) {

  return (

    <div className="custom-modal-body">

      <div className="model-custum">

        <h3>
          {data?.name}
        </h3>

        <div className="view-details-grid">

          {/* STATE ID */}
          {/* <div className="view-detail-card">

            <span>
              State ID
            </span>

            <h5>
              {data?.id}
            </h5>

          </div> */}

          {/* STATE NAME */}
          <div className="view-detail-card">

            <span>
              State Name
            </span>

            <h5>
              {data?.name}
            </h5>

          </div>

          {/* STATUS */}
          <div className="view-detail-card">

            <span>
              Status
            </span>

            <h5>
              {
                data?.status
                  ? "Active"
                  : "Inactive"
              }
            </h5>

          </div>

          {/* CREATED DATE */}
          <div className="view-detail-card">

            <span>
              Created At
            </span>

            <h5>
              {
                new Date(data?.created_at)
                  .toLocaleDateString()
              }
            </h5>

          </div>

        </div>

      </div>

    </div>
  );
}

export default ViewState;